import React, { useEffect } from 'react';
const TaboolaFeed = () => {
  useEffect(() => {
    window._taboola.push({
      article: 'auto',
      url: window.location.href
    });
    window._taboola.push({
      mode: 'alternating-thumbnails-a',
      container: 'taboola-below-article-thumbnails',
      placement: 'Below Article Thumbnails',
      target_type: 'mix'
    });
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    id: "taboola-below-article-thumbnails",
    "data-sentry-component": "TaboolaFeed",
    "data-sentry-source-file": "TaboolaFeed.tsx"
  });
};
export default TaboolaFeed;